import React from "react";

function VirtualTour() {
  return (
    <section id="tour" className="tour py-5">
      <div className="container">
        <div className="row">
          <div className="col-12 text-center mb-3">
            <h3 className="title-prop">Take A virtual tour</h3>
            <h1 className="about text-uppercase text-white">
              Our home virtual tour
            </h1>
            <div className="title-underline my-3 bg-secondary">
              <div className="title-underline-center"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default VirtualTour;
